'use client';

import * as React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BookOpen } from 'lucide-react';

const sunnahs = [
  {
    id: '1',
    title: 'Using the Siwak (Miswak)',
    description:
      "The Prophet (ﷺ) said, 'Siwak cleanses the mouth and pleases the Lord.' It is recommended to use the siwak before prayer, before entering the house, and upon waking up.",
  },
  {
    id: '2',
    title: 'Smiling',
    description:
      'The Prophet (ﷺ) was known for his gentle smile. He said, "Your smiling in the face of your brother is charity." A simple smile can brighten someone\'s day and is considered an act of kindness.',
  },
  {
    id: '3',
    title: 'Entering the home with "Bismillah"',
    description:
      'The Prophet (ﷺ) encouraged saying "Bismillah" (In the name of Allah) upon entering the home. This brings blessings and keeps Shaytan (Satan) from entering.',
  },
  {
    id: '4',
    title: 'Eating with the right hand',
    description:
      "It is a Sunnah to eat and drink with the right hand. The Prophet (ﷺ) instructed, 'When one of you eats, let him eat with his right hand, and when he drinks, let him drink with his right hand, for Satan eats with his left hand and drinks with his left hand.'",
  },
  {
    id: '5',
    title: 'Visiting the sick',
    description:
      'The Prophet (ﷺ) emphasized the importance of visiting the sick, saying it is a right a Muslim has over another. It provides comfort to the ill and is a source of great reward.',
  },
];

export default function SunnahSection() {
  return (
    <Card className="bg-background">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <BookOpen className="text-primary" />
          Sunnahs of the Prophet (ﷺ)
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Accordion type="single" collapsible className="w-full">
          {sunnahs.map((sunnah) => (
            <AccordionItem value={sunnah.id} key={sunnah.id}>
              <AccordionTrigger>{sunnah.title}</AccordionTrigger>
              <AccordionContent>{sunnah.description}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </CardContent>
    </Card>
  );
}
